<div class="container text-center">
    <img [src]=titulo.img class="img-fluid mb-5">
    <div class="container">
        <p style="color: blanchedalmond;">{{titulo.nombre}}</p>
    </div>
    <br>
    <button type="button" class="btn btn-light mt-5" routerLink="home">GO BACK</button>
    <br><br><br><br><br>
</div>